import type { ReactNode } from 'react';
import { observer } from 'mobx-react-lite';

import { DetailCard } from 'components/details/DetailCard';

import type { EditableSchedule } from './EditableSchedule';
import { ScheduleRuleFields } from './ScheduleRuleFields';

interface Props {
  readonly schedule: EditableSchedule;
  /** 1-based position, shown as the card's ordinal badge. */
  readonly index: number;
  readonly dragHandle?: ReactNode;
}

/**
 * One opening rule as a collapsible card, titled "Rule" with the rule's own summary
 * beside it.
 *
 * Its own `observer` rather than inlining the card in the list's render-prop: that
 * prop runs outside any reaction, so `schedule.summary` read there would be captured
 * once and never update — the header would keep describing a rule the operator has
 * since edited. Reading it inside this component's body is what makes it live.
 */
export const ScheduleRuleCard = observer<Props>(({ schedule, index, dragHandle }) => (
  <DetailCard index={index} title="Rule" subtitle={schedule.summary} collapsible dragHandle={dragHandle} onRemove={schedule.delete} removeLabel="Remove rule">
    <ScheduleRuleFields schedule={schedule} />
  </DetailCard>
));
